export enum TransactionType {
    Subscription = "subscription",
    SpaceInsight2020 = "space_insight_2020",
    Report = "report",
}

export type Product = TransactionType;
